/** Debe coincidir con AUTH_PUBLIC_REGISTER en la API. */
export function isPublicRegisterEnabled(): boolean {
  return import.meta.env.VITE_AUTH_PUBLIC_REGISTER === 'true';
}
